function adminFraudRiskManagement() {
	let fraudRiskManagement = [
		{
			name: "Fraud and Risk Management",
			icon: "FraudRisk-management",
			logoName: "MyAccounts",
			// flag: "voucherRequired",
			displayService: "adminFraudRiskManagement",
			items: []
		}
	];

	const dashboard = () => {
		const dashboardArr = [
			{
				path: "/index/AdminFraudRisk-Management",
				name: "Dashboard",
				icon: "dashboard",
				logoName: "dashboard",
				flag: "DASHBOARD"
			}
		];

		return dashboardArr;
	};

	const fraudRiskManagementSub = () => {
		const profileArr = [
			{
				path: "/index/RiskRule",
				name: "Risk Rule",
				icon: "FraudRiskManagement",
				logoName: "riskrules",
				flag:"RISK RULE"
				// flag: "isProfileSetting",
			}
		];

		// if (
		//   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
		// ) {
		return profileArr;
		// } else {
		//   return "";
		// }
	};

	let a = dashboard();
	let b = fraudRiskManagementSub();

	fraudRiskManagement[0].items = [...a, ...b];

	return fraudRiskManagement;
}

export default adminFraudRiskManagement;
